/**
 * Browser copy of pruneConfigByParentField from general-v2-config-helper (pure).
 */

function pruneConfigByParentField(configData, schemaBlock) {
    if (!configData || typeof configData !== "object" || !schemaBlock || typeof schemaBlock !== "object") {
        return configData;
    }

    const prunedConfig = Array.isArray(configData) ? [] : {};

    for (const key in schemaBlock) {
        const schemaField = schemaBlock[key];
        const value = configData[key];

        if (value === undefined) continue;

        let shouldKeepField = true;

        if (schemaField.parent_field && typeof schemaField.parent_field === "object") {
            for (const parentKey in schemaField.parent_field) {
                const allowedValues = schemaField.parent_field[parentKey];
                const actualParentValue = configData[parentKey];

                if (!allowedValues.includes(actualParentValue)) {
                    shouldKeepField = false;
                    break;
                }
            }
        }
        if (!shouldKeepField) continue;

        if (schemaField.items && typeof schemaField.items === "object" && !Array.isArray(schemaField.items)) {
            prunedConfig[key] = pruneConfigByParentField(value, schemaField.items);
        } else if (schemaField.type === "multi-input" && Array.isArray(value)) {
            const itemSchema = schemaField.type_items[0];
            prunedConfig[key] = value
                .map((item) => pruneConfigByParentField(item, itemSchema))
                .filter((item) => Object.keys(item).length > 0);
        } else if (schemaField.type === "multi-input-object" && typeof value === "object" && value !== null) {
            const itemSchema = schemaField.type_items;
            const remappedObject = {};
            for (const itemKey in value) {
                const item = value[itemKey];
                const prunedItem = pruneConfigByParentField(item, itemSchema);
                if (Object.keys(prunedItem).length > 0) {
                    remappedObject[itemKey] = prunedItem;
                }
            }
            prunedConfig[key] = remappedObject;
        } else {
            prunedConfig[key] = value;
        }
    }

    return prunedConfig;
}

export { pruneConfigByParentField };
